import { createPageApp } from '@/lib/createPageApp'
import TeachYourselfBookDescriptionPage from './TeachYourselfBookDescriptionPage.vue'

createPageApp(TeachYourselfBookDescriptionPage).mount()
